import { v2Api } from './v2Client';

const LOG = '[SquashAPI clubSchedule]';

/** 0=dimanche..6=samedi (convention System.DayOfWeek côté API) — ordre d'affichage lundi->dimanche. */
export const DAY_OF_WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0];
export const DAY_OF_WEEK_LABELS = {
  0: 'Dimanche',
  1: 'Lundi',
  2: 'Mardi',
  3: 'Mercredi',
  4: 'Jeudi',
  5: 'Vendredi',
  6: 'Samedi',
};

function normalizeClosureDate(row) {
  if (!row) return null;
  const id = row.id ?? row.Id;
  if (id == null) return null;
  const terrainIdsRaw = row.terrain_ids ?? row.terrainIds ?? [];
  return {
    id: String(id),
    is_recurring: Boolean(row.is_recurring ?? row.isRecurring ?? false),
    start_at: row.start_at ?? row.startAt ?? null,
    end_at: row.end_at ?? row.endAt ?? null,
    day_of_week: row.day_of_week ?? row.dayOfWeek ?? null,
    start_time: row.start_time ?? row.startTime ?? null,
    end_time: row.end_time ?? row.endTime ?? null,
    valid_from: row.valid_from ?? row.validFrom ?? null,
    valid_until: row.valid_until ?? row.validUntil ?? null,
    reason: row.reason ?? row.Reason ?? '',
    // Vide = site-wide (tous les terrains) — voir ClubClosureDateTerrain côté API.
    terrain_ids: Array.isArray(terrainIdsRaw) ? terrainIdsRaw.map(String) : [],
    terrain_names: row.terrain_names ?? row.terrainNames ?? [],
  };
}

/** GET /ClubSchedule/closure_dates — fermetures exceptionnelles, site-wide par défaut mais peuvent être
 * restreintes à un ou plusieurs terrains (voir terrainOpeningHours.service pour les horaires normaux,
 * eux toujours scopés par sport/terrain). */
export async function listClosureDates() {
  try {
    const { data } = await v2Api.get('/ClubSchedule/closure_dates');
    const rows = Array.isArray(data) ? data : [];
    return rows.map(normalizeClosureDate).filter(Boolean);
  } catch (err) {
    console.error(LOG, 'closure_dates échoué', err);
    throw err;
  }
}

/** POST /ClubSchedule/closure_dates/create */
export async function createClosureDate(payload) {
  try {
    const { data } = await v2Api.post('/ClubSchedule/closure_dates/create', payload);
    return normalizeClosureDate(data);
  } catch (err) {
    console.error(LOG, 'closure_dates/create échoué', { payload, err });
    throw err;
  }
}

/** POST /ClubSchedule/closure_dates/delete */
export async function deleteClosureDate(id) {
  try {
    const { data } = await v2Api.post('/ClubSchedule/closure_dates/delete', { id: String(id) });
    return data;
  } catch (err) {
    console.error(LOG, 'closure_dates/delete échoué', { id, err });
    throw err;
  }
}

export const clubScheduleService = {
  listClosureDates,
  createClosureDate,
  deleteClosureDate,
};
